/* eslint-disable array-callback-return */
import {
  Button,
  // Header as HeaderUI,
  IconLogoHeaderWhite,
  Tab,
  TabProps,
} from "@touche-lts/panel-ui/dist";
import { IconCart, IconClose, IconHamburger } from "assets/icons";
import cl from "classnames";
import { observer } from "mobx-react-lite";
import { useRootStore } from "mobx-stores/store-provider";
import { useEffect, useState } from "react";
import { User } from "services";
import styles from "./header.module.scss";
import { Search } from "./search";
import { HeaderProps } from "./header.types";
import { Notifications } from "./notifications";
import { IconSearch } from "../../../assets/icons/svg";
import { StoreSwitcher } from "./store-switcher";
import { useGetIsResponsiveScreen } from "../../../hooks/custom-hooks";

const HeaderComponent = (props: HeaderProps) => {
  const { className, style } = props;
  const {
    routingStore: { push },
    cartCheckoutStore: { getCartByUserId, cartStoreProductsSize },
    notificationsStore: { getNotifications },
  } = useRootStore();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const userDetailsId = JSON.parse(localStorage.getItem("userDetails"))?.id;
  const userRole = JSON.parse(localStorage.getItem("userDetails"))?.role?.name;
  const isStoreAdmin = userRole === "STORE_ADMIN" || userRole === "SUPER_ADMIN";
  const isTempUser = JSON.parse(localStorage.getItem("isTempUser"));
  const { isResponsive: isMobile } =
    useGetIsResponsiveScreen("(max-width: 768px)");

  const tabs: TabProps[] = [
    ...(!User.isStoreAdmin ? [{
      label: 'Stores',
      isSelected: false,
      colorPreset: 'dark' as const,
      className: styles.tab,
      onClick: () => push('/stores')
    }] : []),
    {
      label: "Departments",
      isSelected: false,
      colorPreset: "dark",
      className: styles.tab,
      onClick: () => push("/departments"),
    },
    // {
    //   label: 'Contact us',
    //   isSelected: false,
    //   colorPreset: 'dark',
    //   className: styles.tab,
    //   onClick: undefined
    // }
  ];

  useEffect(() => {
    if (User.isAuthenticated) {
      const interval = setInterval(() => getNotifications(), 30000);
      return () => {
        clearInterval(interval);
      };
    }
    getCartByUserId(userDetailsId);
  }, [getNotifications, getCartByUserId, userDetailsId]);

  useEffect(() => {
    getCartByUserId(userDetailsId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const tabsComponent = (
    <>
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          {...tab}
          onClick={() => {
            tab.onClick?.();
            closeMobileMenu();
          }}
        />
      ))}
    </>
  );

  const rightOptions = (
    <>
      {!isStoreAdmin && (
        <div
          className={styles.cartNumber}
          style={{
            height: "60px",
            display: "flex",
            alignItems: "center",
            padding: "0 20px",
          }}
        >
          <IconCart
            style={{ fill: "white", cursor: "pointer" }}
            onClick={() => {
              push("/cart");
              closeMobileMenu();
            }}
          />
          {cartStoreProductsSize > 0 && <p>{cartStoreProductsSize}</p>}
        </div>
      )}
      {User.isAuthenticated && !isTempUser ? (
        <>
          {!isMobile && <Notifications />}
          <StoreSwitcher closeMobileMenu={closeMobileMenu} />
        </>
      ) : (
        <div
          style={{
            height: "60px",
            display: "flex",
            alignItems: "center",
            padding: "0 20px",
          }}
        >
          <Button
            preset="primary"
            style={{ justifyContent: "center", width: "100%" }}
            onClick={() => {
              push("/login");
              closeMobileMenu();
            }}
          >
            Login
          </Button>
        </div>
      )}
    </>
  );

  const navContent = (
    <>
      {tabsComponent}
      {rightOptions}
    </>
  );

  const desktopSearchComp = (
    <>
      <Button
        preset="icon"
        onClick={() => setIsSearchOpen(!isSearchOpen)}
        className={styles.searchButton}
      >
        {isSearchOpen ? (
          <IconClose width={20} height={20} fill="white" />
        ) : (
          <IconSearch width={20} height={20} fill="white" />
        )}
      </Button>

      {isSearchOpen ? (
        <Search />
      ) : (
        <div className={styles.headerElementsContainer}>{navContent}</div>
      )}
    </>
  );

  return (
    <header className={cl(styles.container, className)} style={style}>
      <div className={styles.logoContainer}>
        <Button preset="icon" onClick={() => push("/")}>
          <IconLogoHeaderWhite />
        </Button>
      </div>

      {!isMobile ? desktopSearchComp : <div></div>}

      {!isMobileMenuOpen && (
        <>
          <Button
            preset="icon"
            className={styles.hamburgerButton}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <IconHamburger width={24} height={24} fill="white" />
          </Button>
          {isMobile && User.isAuthenticated && !isTempUser && <Notifications />}
        </>
      )}

      {isMobileMenuOpen && (
        <>
          <div className={styles.mobileOverlay} onClick={closeMobileMenu} />
          <nav className={styles.mobileMenu}>
            <div className={styles.mobileSearch}>
              <Search />
            </div>
            {tabsComponent}
            {rightOptions}
            <div className={styles.closeButtonContainer}>
              <Button preset="secondary" onClick={closeMobileMenu}>
                <IconClose width={20} height={20} fill="white" />
              </Button>
            </div>
          </nav>
        </>
      )}
    </header>
  );
};

const Header = observer(HeaderComponent);
export { Header };
